

// import axios from "axios";
// import React, { useRef, useState, useEffect, useContext } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import Compressor from "compressorjs";
// import Rightcontainer from "../Components/Rightcontainer";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Header from "../Components/Header";
// import socket from "../Components/socket";
// import Modal from "react-bootstrap/Modal";
// import Spinner from "react-bootstrap/Spinner";
// import { toast, ToastContainer } from "react-toastify";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";

// import {
//   ArrowRight,
//   QrCode,
//   ShieldCheck,
//   Copy,
//   Upload,
//   AlertTriangle,
//   Building2,
//   Coins,
//   Sparkles,
//   Edit2,
//   CheckCircle2,
//   ExternalLink,
//   X,
//   CreditCard
// } from "lucide-react";

// import "react-toastify/dist/ReactToastify.css";
// // import "./Addcase.css";

// const Addcase = ({ walletUpdate }) => {
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;

//   const history = useHistory();
//   let method = useRef();
//   let checkInterval;
//   const [userAllData, setUserAllData] = useState();

//   const access_token = localStorage.getItem("token");

//   const [isLoading1, setIsloading1] = useState(false);
//   const [global, setGlobal] = useState(100);
//   const [next, setNext] = useState(1);
//   const [process1, setProcess] = useState(false);
//   const [isMobile, setMobile] = useState(false);

//   const [isCashFreeActive, setCashFreeActive] = useState(true);
//   const [isPhonePayActive, setIsPhonePayActive] = useState(false);
//   const [isAirPayActive, setIsAirPayActive] = useState(false);
//   const [payinOne, setPayinOne] = useState(false);
//   const [payinTwo, setPayinTwo] = useState(false);
//   const [isUpiGateway, setUpiGateway] = useState(false);
//   const [isUpiGateway02, setUpiGateway02] = useState(false);
//   const [isUpiGateway03, setUpiGateway03] = useState(false);
//   const [isMyPayActive, setIsMyPayActive] = useState(false);
//   const [isPineLabActive, setPineLabActive] = useState(false);
//   const [isRazorPayActive, setRazorPayActive] = useState(false);
//   const [isDecentroActive, setDecentroActive] = useState(false);
//   const [isHoadaPaypayInActive, setHoadaPaypayInActive] = useState(false);
//   const [ManualPaymentdata, setManualPaymentdata] = useState([]);

//   const [manualData, setManualData] = useState([]);
//   const [PayOneImage, setPayOneImage] = useState("");
//   const [PayTwoImage, setPayTwoImage] = useState("");
//   const [PayThreeImage, setPayThreeImage] = useState("");
//   const [PayFourImage, setPayFourImage] = useState("");
//   const [PayFiveImage, setPayFiveImage] = useState("");

//   // hooks for payment url
//   const [PayNow1Url, setPaynow1Url] = useState("");
//   const [PayNow2Url, setPaynow2Url] = useState("");
//   const [PayNow3Url, setPaynow3Url] = useState("");
//   const [PayNow4Url, setPaynow4Url] = useState("");
//   const [PayNow5Url, setPaynow5Url] = useState("");

//   const [show_won, setShow_won] = useState(false);
//   const handleClose_won = () => setShow_won(false);
//   const [scrnshot, setScrnshot] = useState(null);
//   const [fecthStatus, setFecthStatus] = useState();
//   const [scrnshot1, setScrnshot1] = useState("");
//   const handleShow_won = () => setShow_won(true);

//   const [qrCode, setQrCode] = useState();
//   const [walletOption, setWalletOption] = useState("airtel");
//   const [bankCode, setBankCode] = useState(3003);

//   const [account_mail_id, setAccount_mail_id] = useState();
//   const [account_name, setAccount_name] = useState();
//   const [accountPhone, setAccountPhone] = useState();
//   const [isLoading, setIsLoading] = useState(false);

//   const [minLimit, setMinLimit] = useState(null);
//   const [maxLimit, setMaxLimit] = useState(null);
//   const [amount, setamount] = useState("");
//   const [utr, setutr] = useState("");
//   const [pgUpiGateway, setPGGateway] = useState(false);

//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = addsetting ? JSON.parse(addsetting) : {};

//   const [hoadaPay, setHoadaPay] = useState(false);

//   useEffect(() => {
//     setMinLimit(addCaseSetting.depositlimitMin || 10);
//     setMaxLimit(addCaseSetting.depositlimitMax || 50000);
//   }, []);

//   const handleNext = () => {
//     if (global < minLimit || global > maxLimit) {
//       toast.error(
//         `Minimum amount should be > ₹${minLimit} and maximum < ₹${maxLimit}`,
//         { position: "top-center", theme: "dark" }
//       );
//     } else {
//       setNext(2);
//     }
//   };

//   // Toast Helper
//   const showSuccessToast = (msg) => {
//     toast.success(msg, {
//       position: "top-center",
//       autoClose: 2000,
//       theme: "dark",
//     });
//   };

//   const showErrorToast = (msg) => {
//     toast.error(msg, {
//       position: "top-center",
//       autoClose: 2500,
//       theme: "dark",
//     });
//   };

//   // Upigateway Functions
//   const upigateway02 = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     const respone = await apiRequest(
//       `user/depositeupi02?amount=${global.toFixed(2)}`,
//       "POST",
//       { amount: global },
//       headers
//     );

//     if (respone?.data?.data?.status) {
//       let order_id = respone.data.txnID;
//       let order_token = respone.data.data.data.order_id;
//       window.open(respone.data.data.data.payment_url);
//       setTimeout(() => {
//         checkupideposit(order_id, order_token);
//         setProcess(false);
//       }, 60000);
//     } else {
//       setProcess(false);
//       showErrorToast(respone?.data?.data?.msg || "Payment Failed");
//     }
//   };

//   const pgupigateway = () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios
//       .post(
//         baseUrl + `/pg-upigateway?amount=${global.toFixed(2)}`,
//         { amount: global },
//         { headers }
//       )
//       .then((res) => {
//         if (res.data?.data?.result) {
//           window.open(res.data.data.result.payment_url);
//           setTimeout(() => {
//             setProcess(false);
//           }, 60000);
//         } else {
//           setProcess(false);
//           showErrorToast(res.data?.data?.msg || "Payment gateway error");
//         }
//       })
//       .catch((e) => {
//         setProcess(false);
//         showErrorToast("Error connecting to gateway");
//       });
//   };

//   const fetchPaymentUrl = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access_token}`,
//     };
//     try {
//       setIsLoading(true);
//       const respone = await apiRequest(
//         `phonpay-request?amount=${global}`,
//         "GET",
//         null,
//         headers
//       );

//       if (respone) {
//         setIsLoading(false);
//         window.location.href = respone.data.instrumentResponse.redirectInfo.url;
//       }
//     } catch (error) {
//       console.error("Error fetching payment URL:", error);
//       setIsLoading(false);
//       showErrorToast("Failed to launch PhonePe session");
//     }
//   };

//   const payinnn = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     const res = await apiRequest(
//       "zap-upigateway",
//       "POST",
//       { amount: global },
//       headers
//     );
//     setProcess(false);
//     if (res?.data?.status === false) {
//       showErrorToast(res.data.msg);
//     } else if (res?.data) {
//       if (res.data?.data?.payment_url) {
//         window.open(res.data?.data?.payment_url, "_blank");
//       }
//     } else {
//       showErrorToast("Transaction initialization failed");
//     }
//   };

//   const paymy = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     const res = await apiRequest(
//       "camlenio/payin01",
//       "POST",
//       { amount: global },
//       headers
//     );
//     setProcess(false);
//     if (res?.data?.status === false) {
//       showErrorToast(res.data.msg);
//     } else if (res?.data) {
//       if (res.data?.payload?.web) {
//         window.open(res.data?.payload?.web, "_blank");
//       }
//     } else {
//       showErrorToast("Gateway Error");
//     }
//   };

//   const checkupideposit = async (order_id, order_token) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     const respone = await apiRequest(
//       `depositupipay/response`,
//       "POST",
//       { order_id, order_token },
//       headers
//     );

//     if (respone?.data?.status === "PAID") {
//       showSuccessToast("Deposit submitted successfully!");
//     } else {
//       showErrorToast("Transaction Failed");
//     }
//     history.push("/");
//   };

//   const meeApi = async () => {
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     try {
//       const respone = await apiRequest("me", "GET", null, headers);
//       setUserAllData(respone.data);
//       setAccount_mail_id(respone.data.Email);
//       setAccount_name(respone.data.holder_name);
//       setAccountPhone(respone.data.Phone);
//     } catch (e) {}

//     try {
//       const res = await apiRequest(`website/setting`, "GET", null);
//       setCashFreeActive(res.data.isCashFreeActive);
//       setRazorPayActive(res.data.isRazorPayActive);
//       setDecentroActive(res.data.isDecentroActive);
//       setPineLabActive(res.data.isPineLabActive);
//       setIsPhonePayActive(res.data.isPhonePayActive);
//       setIsAirPayActive(res.data.isAirPayActive);
//       setIsMyPayActive(res.data.isMyPayActive);
//       setHoadaPaypayInActive(res.data.isHaodaPayPayInActive);
//     } catch (e) {}

//     if (
//       /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//         navigator.userAgent
//       )
//     ) {
//       setMobile(true);
//     }
//   };

//   useEffect(() => {
//     meeApi();
//   }, []);

//   const clearImage = () => {
//     setScrnshot1(null);
//     setScrnshot(null);
//   };

//   const handleChange = (e) => {
//     setScrnshot1(URL.createObjectURL(e.target.files[0]));
//     const image = e.target.files[0];
//     if (image && image.size / 1000 > 300) {
//       new Compressor(image, {
//         quality: 0.6,
//         success(compressedResult) {
//           setScrnshot(compressedResult || image);
//         },
//       });
//     } else {
//       setScrnshot(e.target.files[0]);
//     }
//   };

//   const ManualPayment = async () => {
//     const access_token = localStorage.getItem("token");
//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", `Bearer ${access_token}`);

//     try {
//       const result = await apiRequest(
//         "gatewaysettings/data",
//         "GET",
//         null,
//         myHeaders
//       );
//       setManualData(result.data);
//       setPaynow1Url(result?.data?.paynow1Url);
//       setPayOneImage(result?.data?.isPayOneImage);
//       setPayTwoImage(result?.data?.isPayTwoImage);
//       setPayThreeImage(result?.data?.isPayThreeImage);
//       setPayFourImage(result?.data?.isPayFourImage);
//       setPayFiveImage(result?.data?.isPayFiveImage);
//       setIsMyPayActive(result?.data?.isMypayInActive);
//       setPayinOne(result?.data?.payinOne);
//       setPayinTwo(result?.data?.payinTwo);
//       setUpiGateway(result?.data?.isUpiGateway);
//       setUpiGateway02(result?.data?.isUpiGateway02);
//       setUpiGateway03(result?.data?.isUpiGateway03);
//       setPGGateway(result?.data?.isPgUpiGateway);
//     } catch (error) {}
//   };

//   useEffect(() => {
//     ManualPayment();
//   }, []);

//   const [ImageUrl, setImageUrl] = useState("");
//   const [PaymentLink, setPaymentLink] = useState("");

//   const getImageUrl = (image, url) => {
//     setImageUrl(image);
//     setPaymentLink(url);
//   };

//   // Copy code handlers
//   const copyCode = () => {
//     navigator.clipboard.writeText(PayNow1Url);
//     showSuccessToast("Payment Link Copied!");
//   };

//   const copyCode1 = () => {
//     navigator.clipboard.writeText(manualData?.acNo);
//     showSuccessToast("Account Number Copied!");
//   };

//   const copyCode2 = () => {
//     navigator.clipboard.writeText(manualData?.acName);
//     showSuccessToast("Beneficiary Name Copied!");
//   };

//   const copyCode3 = () => {
//     navigator.clipboard.writeText(manualData?.ifsccode);
//     showSuccessToast("IFSC Code Copied!");
//   };

//   const ManualPayments = async () => {
//     setIsloading1(true);
//     var formdata = new FormData();
//     formdata.append("Transaction_Screenshot", scrnshot);
//     formdata.append("amount", global);
//     formdata.append("referenceId", utr);

//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     const result = await apiRequest(
//       "manual/deposit/txn",
//       "POST",
//       formdata,
//       headers
//     );
//     setIsloading1(false);

//     if (result?.data?.status === "Pending") {
//       showSuccessToast(result?.data?.message || "Deposit request submitted!");
//     } else {
//       showErrorToast(result?.data?.message || "Failed to submit deposit.");
//     }
//     history.push("/");
//     handleClose_won();
//   };

//   const handleIMBGateway = async () => {
//     try {
//       const access_token = localStorage.getItem("token");
//       const finalAmount = amount || global;

//       if (!finalAmount || finalAmount <= 0) {
//         return showErrorToast("Enter a valid deposit amount");
//       }

//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(
//         `imb-request?amount=${finalAmount}`,
//         "GET",
//         null,
//         headers
//       );

//       if (res?.data?.status === true && res?.data?.payment_url) {
//         showSuccessToast("Redirecting to payment gateway...");
//         setTimeout(() => {
//           window.location.href = res.data.payment_url;
//         }, 1200);
//       } else {
//         showErrorToast(res?.data?.msg || "Payment Failed");
//       }
//     } catch (err) {
//       showErrorToast("Connection Failed. Please try again.");
//     }
//   };

//   const translations = {
//     hi: {
//       addMoney: "पैसे जोड़ने के लिए राशि चुनें",
//       money: "राशि डालें (₹)",
//       next: "आगे बढ़ें",
//       addAmount: "राशि जोड़ी जानी है:",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       addMoney: "Choose Amount to Add",
//       money: "Enter Amount (₹)",
//       next: "Proceed to Pay",
//       addAmount: "Amount to be added:",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);
//   const t = translations[language] || translations.en;

//   return (
//     <>
//       <Header user={userAllData} />
//       <ToastContainer limit={3} />

//       <div className="addcase-page-wrapper leftContainer mb_space mt-5 pt-5">
//         {/* Background Ambient Glowing Lights */}
//         <div className="addcase-ambient glow-1"></div>
//         <div className="addcase-ambient glow-2"></div>
//         <div className="addcase-ambient glow-3"></div>

//         <div className="addcase-main-container">
//           {!process1 && (
//             <div>
//               {/* --- STEP 1: SELECT AMOUNT --- */}
//               {next === 1 && (
//                 <div className="addcase-card animate-fade">
//                   <div className="card-header-badge">
//                     <div className="header-badge-pill">
//                       <Coins size={16} className="badge-icon-spin" />
//                       <span>Instant Add Money</span>
//                     </div>
//                     <h2 className="card-main-title">{t.addMoney}</h2>
//                   </div>

//                   <div className="amount-input-block">
//                     <label className="amount-label">{t.money}</label>
//                     <div className="amount-input-wrapper">
//                       <span className="currency-prefix">₹</span>
//                       <input
//                         className="amount-field"
//                         type="tel"
//                         placeholder="Min 10, Max 50000"
//                         value={global}
//                         onChange={(e) => {
//                           const val = parseInt(e.target.value) || 0;
//                           if (val > 50000) setGlobal(50000);
//                           else setGlobal(val);
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div className="quick-chips-grid">
//                     {[100, 250, 500, 2000].map((chipVal) => (
//                       <button
//                         key={chipVal}
//                         type="button"
//                         className={`chip-btn ${
//                           global === chipVal ? "active" : ""
//                         }`}
//                         onClick={() => setGlobal(chipVal)}
//                       >
//                         <Sparkles size={14} className="chip-sparkle" />
//                         <span>+₹{chipVal}</span>
//                       </button>
//                     ))}
//                   </div>

//                   <div className="action-btn-area">
//                     {addCaseSetting.isDeposit ? (
//                       <button
//                         type="button"
//                         className="primary-gradient-btn pulse-hover"
//                         onClick={handleNext}
//                       >
//                         <span>{t.next}</span>
//                         <ArrowRight className="btn-arrow" size={18} />
//                       </button>
//                     ) : (
//                       <div className="service-closed-banner">
//                         <AlertTriangle className="alert-icon" size={18} />
//                         <span>Deposit services are temporarily paused.</span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* --- STEP 2: CHOOSE PAYMENT METHOD --- */}
//               {next === 2 && (
//                 <div className="addcase-card animate-fade">
//                   <div className="amount-summary-strip">
//                     <div className="summary-left">
//                       <span className="summary-label">{t.addAmount}</span>
//                       <span className="summary-val">₹{global}</span>
//                     </div>
//                     <button
//                       type="button"
//                       onClick={() => setNext(1)}
//                       className="edit-amount-btn"
//                     >
//                       <Edit2 size={13} /> Edit
//                     </button>
//                   </div>

//                   <div className="section-divider-title">
//                     <span>Select Payment Option</span>
//                   </div>

//                   <div className="gateways-list">
//                     {/* PhonePe */}
//                     {Boolean(isPhonePayActive) && (
//                       <div
//                         onClick={() => fetchPaymentUrl()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Pay Now Option 1</strong>
//                             <span>Instant Auto-Credit</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     )}

//                     {/* IMB / UPI Gateway 1 */}
//                     {global >= manualData?.upiGatewayMin &&
//                     Boolean(isUpiGateway) &&
//                     global <= manualData?.upiGatewayMax ? (
//                       <div
//                         onClick={() => handleIMBGateway()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Scan QR Code (Instant)</strong>
//                             <span>Auto approval gateway</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* UPI Gateway 02 */}
//                     {global >= manualData?.upiGatewayMin2 &&
//                     Boolean(isUpiGateway02) &&
//                     global <= manualData?.upiGatewayMax2 ? (
//                       <div
//                         onClick={() => upigateway02()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Pay QR Code Option 2</strong>
//                             <span>Fast processing</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* PG UPI Gateway 03 */}
//                     {global >= manualData?.upiGatewayMin3 &&
//                     Boolean(isUpiGateway03) &&
//                     global <= manualData?.upiGatewayMax3 ? (
//                       <div
//                         onClick={() => pgupigateway()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Pay QR Code Option 3</strong>
//                             <span>Seamless checkout</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* Payin One */}
//                     {global >= manualData?.payinMin &&
//                     Boolean(payinOne) &&
//                     global <= manualData?.payinMax ? (
//                       <div
//                         onClick={() => payinnn()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Express Pay Now</strong>
//                             <span>Direct UPI redirect</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* Payin Two */}
//                     {global >= manualData?.payinMin &&
//                     Boolean(payinTwo) &&
//                     global <= manualData?.payinMax ? (
//                       <div
//                         onClick={() => paymy()}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <img src="/UPI.png" alt="UPI" className="gw-logo" />
//                           <div className="gw-text">
//                             <strong>Express Pay Option 2</strong>
//                             <span>Quick payment link</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* Pay with Account Transfer */}
//                     {manualData?.isAccountActive &&
//                     global >= manualData?.upiMin &&
//                     global <= manualData?.upiMax ? (
//                       <div
//                         onClick={() => setNext(4)}
//                         className="gateway-option-card bank-card"
//                       >
//                         <div className="gateway-card-left">
//                           <div className="bank-icon-box">
//                             <Building2 size={22} />
//                           </div>
//                           <div className="gw-text">
//                             <strong>Bank Account Transfer</strong>
//                             <span>IMPS / NEFT / RTGS</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* Manual QR Code 1 */}
//                     {manualData?.isPayNowOne &&
//                     global >= manualData?.upiMin &&
//                     global <= manualData?.upiMax ? (
//                       <div
//                         onClick={() => {
//                           setNext(3);
//                           getImageUrl(PayOneImage, PayNow1Url);
//                         }}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <div className="bank-icon-box cyan">
//                             <QrCode size={22} />
//                           </div>
//                           <div className="gw-text">
//                             <strong>Manual QR Code 1</strong>
//                             <span>Scan and upload UTR</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}

//                     {/* Manual QR Code 2 */}
//                     {manualData?.isPayNowTwo ? (
//                       <div
//                         onClick={() => {
//                           setNext(3);
//                           getImageUrl(PayTwoImage, PayNow2Url);
//                         }}
//                         className="gateway-option-card"
//                       >
//                         <div className="gateway-card-left">
//                           <div className="bank-icon-box cyan">
//                             <QrCode size={22} />
//                           </div>
//                           <div className="gw-text">
//                             <strong>Manual QR Code 2</strong>
//                             <span>Scan and upload UTR</span>
//                           </div>
//                         </div>
//                         <ArrowRight className="gw-arrow" size={18} />
//                       </div>
//                     ) : null}
//                   </div>

//                   {/* WhatsApp Support Deposit Option */}
//                   {global >= manualData?.whatsappRangemin &&
//                     Boolean(manualData?.whatsappDeposit) &&
//                     global <= manualData?.whatsappRangemax && (
//                       <div className="whatsapp-deposit-container">
//                         <div className="wa-deposit-info">
//                           <h5>Manual WhatsApp Deposit</h5>
//                           <p>{addCaseSetting?.whatsappDepositmsg}</p>
//                         </div>
//                         <a
//                           className="whatsapp-action-btn"
//                           href={`https://wa.me/+91${addCaseSetting?.whatsappDepositNo}`}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           <ExternalLink size={16} />
//                           <span>Connect on WhatsApp</span>
//                         </a>
//                       </div>
//                     )}
//                 </div>
//               )}

//               {/* --- STEP 3: MANUAL QR & UTR SCREEN --- */}
//               {next === 3 && (
//                 <div className="addcase-card animate-fade">
//                   <div className="notice-box warning">
//                     <AlertTriangle className="notice-icon" size={18} />
//                     <span>
//                       कृपया सुनिश्चित करें कि आप मैन्युअल डिपॉजिट अमाउंट के
//                       बराबर ही भुगतान करें। UTR नंबर और स्क्रीनशॉट के बिना कम या
//                       ज्यादा पेमेंट ऐड नहीं होगा।
//                     </span>
//                   </div>

//                   <div className="manual-qr-display-box">
//                     <h4 className="qr-title">Scan & Pay ₹{global}</h4>
//                     <div className="qr-img-frame">
//                       <img
//                         src={`${baseUrl}/${ImageUrl}`}
//                         alt="Payment QR Code"
//                         className="qr-img"
//                       />
//                     </div>

//                     {PayNow1Url && (
//                       <div className="copy-url-bar">
//                         <span className="url-text">{PayNow1Url}</span>
//                         <button className="copy-sm-btn" onClick={copyCode}>
//                           <Copy size={14} /> Copy
//                         </button>
//                       </div>
//                     )}
//                   </div>

//                   <button
//                     className="primary-gradient-btn"
//                     onClick={handleShow_won}
//                   >
//                     <Upload className="btn-icon" size={18} />
//                     <span>Upload Payment Details</span>
//                   </button>
//                 </div>
//               )}

//               {/* --- STEP 4: BANK ACCOUNT DETAILS SCREEN --- */}
//               {next === 4 && (
//                 <div className="addcase-card animate-fade">
//                   <div className="notice-box info">
//                     <ShieldCheck className="notice-icon" size={18} />
//                     <span>
//                       पेमेंट करने के बाद स्क्रीनशॉट और UTR नंबर डालकर सबमिट करें।
//                       गलत डिटेल्स डालने पर डिपॉजिट ऐड नहीं होगा।
//                     </span>
//                   </div>

//                   <div className="bank-details-card">
//                     <div className="bank-detail-row">
//                       <span className="detail-label">Account Number</span>
//                       <div className="detail-value-wrap">
//                         <strong className="detail-value">
//                           {manualData?.acNo || "N/A"}
//                         </strong>
//                         <button className="copy-sm-btn" onClick={copyCode1}>
//                           <Copy size={14} />
//                         </button>
//                       </div>
//                     </div>

//                     <div className="bank-detail-row">
//                       <span className="detail-label">Beneficiary Name</span>
//                       <div className="detail-value-wrap">
//                         <strong className="detail-value">
//                           {manualData?.acName || "N/A"}
//                         </strong>
//                         <button className="copy-sm-btn" onClick={copyCode2}>
//                           <Copy size={14} />
//                         </button>
//                       </div>
//                     </div>

//                     <div className="bank-detail-row">
//                       <span className="detail-label">IFSC Code</span>
//                       <div className="detail-value-wrap">
//                         <strong className="detail-value">
//                           {manualData?.ifsccode || "N/A"}
//                         </strong>
//                         <button className="copy-sm-btn" onClick={copyCode3}>
//                           <Copy size={14} />
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   <button
//                     className="primary-gradient-btn"
//                     onClick={handleShow_won}
//                   >
//                     <Upload className="btn-icon" size={18} />
//                     <span>Upload Payment Details</span>
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}

//           {process1 && (
//             <div className="loader-overlay">
//               <img
//                 src="/images/LandingPage_img/loaderred.gif"
//                 alt="Loading..."
//                 className="loader-gif"
//               />
//             </div>
//           )}
//         </div>

//         {/* --- UPLOAD DETAILS MODAL --- */}
//         <Modal
//           show={show_won}
//           onHide={handleClose_won}
//           className="dark-custom-modal"
//           centered
//         >
//           <Modal.Header closeButton className="dark-modal-header">
//             <Modal.Title className="modal-title-custom">
//               Submit Payment Proof
//             </Modal.Title>
//           </Modal.Header>

//           <Modal.Body className="dark-modal-body">
//             <div className="form-field-group">
//               <label className="field-label">Amount (₹)</label>
//               <input
//                 className="dark-input-readonly"
//                 type="number"
//                 value={global}
//                 readOnly
//               />
//             </div>

//             <div className="form-field-group mt-3">
//               <label className="field-label">
//                 12-Digit UTR / Reference No.
//               </label>
//               <input
//                 className="dark-input-field"
//                 type="text"
//                 value={utr}
//                 onChange={(e) => setutr(e.target.value)}
//                 placeholder="Enter 12-digit UTR Number"
//                 required
//               />
//             </div>

//             <div className="file-upload-dropzone mt-3">
//               <input
//                 type="file"
//                 onChange={handleChange}
//                 accept="image/*"
//                 required
//                 className="file-input-hidden"
//               />
//               {!scrnshot ? (
//                 <div className="dropzone-placeholder">
//                   <Upload className="dz-icon" size={24} />
//                   <span>Click to Upload Payment Screenshot</span>
//                 </div>
//               ) : (
//                 <div className="uploaded-file-info">
//                   <CheckCircle2 size={18} className="file-check-icon" />
//                   <span className="file-name-text">{scrnshot.name}</span>
//                   <button
//                     type="button"
//                     className="clear-file-btn"
//                     onClick={clearImage}
//                   >
//                     <X size={14} /> Remove
//                   </button>
//                 </div>
//               )}
//             </div>

//             {scrnshot1 && (
//               <div className="screenshot-preview-wrapper mt-3">
//                 <img
//                   src={scrnshot1}
//                   alt="Preview"
//                   className="ss-preview-img"
//                 />
//               </div>
//             )}

//             <div className="modal-actions-area mt-4">
//               {isLoading1 ? (
//                 <button className="primary-gradient-btn" disabled>
//                   <Spinner animation="border" size="sm" /> Submitting...
//                 </button>
//               ) : (
//                 <button
//                   type="button"
//                   className="primary-gradient-btn"
//                   onClick={ManualPayments}
//                   disabled={!utr || !scrnshot}
//                 >
//                   Submit Payment Details
//                 </button>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>

//         <div className="rightContainer mobile-hide">
//           <Rightcontainer />
//         </div>
//       </div>
//     </>
//   );
// };

// export default Addcase;



import axios from "axios";
import React, { useRef, useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Compressor from "compressorjs";
import Rightcontainer from "../Components/Rightcontainer";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { LanguageContext } from "../Components/LanguageContext";
import { apiRequest } from "../../apiService/allApi";

import {
  ArrowRight,
  QrCode,
  ShieldCheck,
  Copy,
  Upload,
  AlertTriangle,
  Building2,
  Coins,
  Sparkles,
  Edit2,
  CheckCircle2,
  ExternalLink,
  X,
  Zap,
  Lock,
  Wallet
} from "lucide-react";

import "react-toastify/dist/ReactToastify.css";
// import "../css/Addcase.css";

const Addcase = ({ walletUpdate }) => {
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;

  const history = useHistory();
  let method = useRef();
  let checkInterval;
  const [userAllData, setUserAllData] = useState();

  const access_token = localStorage.getItem("token");

  const [isLoading1, setIsloading1] = useState(false);
  const [global, setGlobal] = useState(100);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);
  const [isMobile, setMobile] = useState(false);

  const [isCashFreeActive, setCashFreeActive] = useState(true);
  const [isPhonePayActive, setIsPhonePayActive] = useState(false);
  const [isAirPayActive, setIsAirPayActive] = useState(false);
  const [payinOne, setPayinOne] = useState(false);
  const [payinTwo, setPayinTwo] = useState(false);
  const [isUpiGateway, setUpiGateway] = useState(false);
  const [isUpiGateway02, setUpiGateway02] = useState(false);
  const [isUpiGateway03, setUpiGateway03] = useState(false);
  const [isMyPayActive, setIsMyPayActive] = useState(false);
  const [isPineLabActive, setPineLabActive] = useState(false);
  const [isRazorPayActive, setRazorPayActive] = useState(false);
  const [isDecentroActive, setDecentroActive] = useState(false);
  const [isHoadaPaypayInActive, setHoadaPaypayInActive] = useState(false);
  const [ManualPaymentdata, setManualPaymentdata] = useState([]);

  const [manualData, setManualData] = useState([]);
  const [PayOneImage, setPayOneImage] = useState("");
  const [PayTwoImage, setPayTwoImage] = useState("");
  const [PayThreeImage, setPayThreeImage] = useState("");
  const [PayFourImage, setPayFourImage] = useState("");
  const [PayFiveImage, setPayFiveImage] = useState("");

  // hooks for payment url
  const [PayNow1Url, setPaynow1Url] = useState("");
  const [PayNow2Url, setPaynow2Url] = useState("");
  const [PayNow3Url, setPaynow3Url] = useState("");
  const [PayNow4Url, setPaynow4Url] = useState("");
  const [PayNow5Url, setPaynow5Url] = useState("");

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot1, setScrnshot1] = useState("");
  const handleShow_won = () => setShow_won(true);

  const [qrCode, setQrCode] = useState();
  const [walletOption, setWalletOption] = useState("airtel");
  const [bankCode, setBankCode] = useState(3003);

  const [account_mail_id, setAccount_mail_id] = useState();
  const [account_name, setAccount_name] = useState();
  const [accountPhone, setAccountPhone] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [amount, setamount] = useState("");
  const [utr, setutr] = useState("");
  const [pgUpiGateway, setPGGateway] = useState(false);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = addsetting ? JSON.parse(addsetting) : {};

  const [hoadaPay, setHoadaPay] = useState(false);

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin || 10);
    setMaxLimit(addCaseSetting.depositlimitMax || 50000);
  }, []);

  const handleNext = () => {
    if (global < minLimit || global > maxLimit) {
      toast.error(
        `Minimum amount should be > ₹${minLimit} and maximum < ₹${maxLimit}`,
        { position: "top-center", theme: "dark" }
      );
    } else {
      setNext(2);
    }
  };

  // Toast Helper
  const showSuccessToast = (msg) => {
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000,
      theme: "dark",
    });
  };

  const showErrorToast = (msg) => {
    toast.error(msg, {
      position: "top-center",
      autoClose: 2500,
      theme: "dark",
    });
  };

  // Upigateway Functions
  const upigateway02 = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const respone = await apiRequest(
      `user/depositeupi02?amount=${global.toFixed(2)}`,
      "POST",
      { amount: global },
      headers
    );

    if (respone?.data?.data?.status) {
      let order_id = respone.data.txnID;
      let order_token = respone.data.data.data.order_id;
      window.open(respone.data.data.data.payment_url);
      setTimeout(() => {
        checkupideposit(order_id, order_token);
        setProcess(false);
      }, 60000);
    } else {
      setProcess(false);
      showErrorToast(respone?.data?.data?.msg || "Payment Failed");
    }
  };

  const pgupigateway = () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    axios
      .post(
        baseUrl + `/pg-upigateway?amount=${global.toFixed(2)}`,
        { amount: global },
        { headers }
      )
      .then((res) => {
        if (res.data?.data?.result) {
          window.open(res.data.result.payment_url);
          setTimeout(() => {
            setProcess(false);
          }, 60000);
        } else {
          setProcess(false);
          showErrorToast(res.data?.data?.msg || "Payment gateway error");
        }
      })
      .catch((e) => {
        setProcess(false);
        showErrorToast("Error connecting to gateway");
      });
  };

  const fetchPaymentUrl = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    };
    try {
      setIsLoading(true);
      const respone = await apiRequest(
        `phonpay-request?amount=${global}`,
        "GET",
        null,
        headers
      );

      if (respone) {
        setIsLoading(false);
        window.location.href = respone.data.instrumentResponse.redirectInfo.url;
      }
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
      showErrorToast("Failed to launch PhonePe session");
    }
  };

  const payinnn = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const res = await apiRequest(
      "zap-upigateway",
      "POST",
      { amount: global },
      headers
    );
    setProcess(false);
    if (res?.data?.status === false) {
      showErrorToast(res.data.msg);
    } else if (res?.data) {
      if (res.data?.data?.payment_url) {
        window.open(res.data?.data?.payment_url, "_blank");
      }
    } else {
      showErrorToast("Transaction initialization failed");
    }
  };

  const paymy = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const res = await apiRequest(
      "camlenio/payin01",
      "POST",
      { amount: global },
      headers
    );
    setProcess(false);
    if (res?.data?.status === false) {
      showErrorToast(res.data.msg);
    } else if (res?.data) {
      if (res.data?.payload?.web) {
        window.open(res.data?.payload?.web, "_blank");
      }
    } else {
      showErrorToast("Gateway Error");
    }
  };

  const checkupideposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const respone = await apiRequest(
      `depositupipay/response`,
      "POST",
      { order_id, order_token },
      headers
    );

    if (respone?.data?.status === "PAID") {
      showSuccessToast("Deposit submitted successfully!");
    } else {
      showErrorToast("Transaction Failed");
    }
    history.push("/");
  };

  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const respone = await apiRequest("me", "GET", null, headers);
      setUserAllData(respone.data);
      setAccount_mail_id(respone.data.Email);
      setAccount_name(respone.data.holder_name);
      setAccountPhone(respone.data.Phone);
    } catch (e) {}

    try {
      const res = await apiRequest(`website/setting`, "GET", null);
      setCashFreeActive(res.data.isCashFreeActive);
      setRazorPayActive(res.data.isRazorPayActive);
      setDecentroActive(res.data.isDecentroActive);
      setPineLabActive(res.data.isPineLabActive);
      setIsPhonePayActive(res.data.isPhonePayActive);
      setIsAirPayActive(res.data.isAirPayActive);
      setIsMyPayActive(res.data.isMyPayActive);
      setHoadaPaypayInActive(res.data.isHaodaPayPayInActive);
    } catch (e) {}

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      setMobile(true);
    }
  };

  useEffect(() => {
    meeApi();
  }, []);

  const clearImage = () => {
    setScrnshot1(null);
    setScrnshot(null);
  };

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          setScrnshot(compressedResult || image);
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    const access_token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${access_token}`);

    try {
      const result = await apiRequest(
        "gatewaysettings/data",
        "GET",
        null,
        myHeaders
      );
      setManualData(result.data);
      setPaynow1Url(result?.data?.paynow1Url);
      setPayOneImage(result?.data?.isPayOneImage);
      setPayTwoImage(result?.data?.isPayTwoImage);
      setPayThreeImage(result?.data?.isPayThreeImage);
      setPayFourImage(result?.data?.isPayFourImage);
      setPayFiveImage(result?.data?.isPayFiveImage);
      setIsMyPayActive(result?.data?.isMypayInActive);
      setPayinOne(result?.data?.payinOne);
      setPayinTwo(result?.data?.payinTwo);
      setUpiGateway(result?.data?.isUpiGateway);
      setUpiGateway02(result?.data?.isUpiGateway02);
      setUpiGateway03(result?.data?.isUpiGateway03);
      setPGGateway(result?.data?.isPgUpiGateway);
    } catch (error) {}
  };

  useEffect(() => {
    ManualPayment();
  }, []);

  const [ImageUrl, setImageUrl] = useState("");
  const [PaymentLink, setPaymentLink] = useState("");

  const getImageUrl = (image, url) => {
    setImageUrl(image);
    setPaymentLink(url);
  };

  // Copy code handlers
  const copyCode = () => {
    navigator.clipboard.writeText(PayNow1Url);
    showSuccessToast("Payment Link Copied!");
  };

  const copyCode1 = () => {
    navigator.clipboard.writeText(manualData?.acNo);
    showSuccessToast("Account Number Copied!");
  };

  const copyCode2 = () => {
    navigator.clipboard.writeText(manualData?.acName);
    showSuccessToast("Beneficiary Name Copied!");
  };

  const copyCode3 = () => {
    navigator.clipboard.writeText(manualData?.ifsccode);
    showSuccessToast("IFSC Code Copied!");
  };

  const ManualPayments = async () => {
    setIsloading1(true);
    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const result = await apiRequest(
      "manual/deposit/txn",
      "POST",
      formdata,
      headers
    );
    setIsloading1(false);

    if (result?.data?.status === "Pending") {
      showSuccessToast(result?.data?.message || "Deposit request submitted!");
    } else {
      showErrorToast(result?.data?.message || "Failed to submit deposit.");
    }
    history.push("/");
    handleClose_won();
  };

  const handleIMBGateway = async () => {
    try {
      const access_token = localStorage.getItem("token");
      const finalAmount = amount || global;

      if (!finalAmount || finalAmount <= 0) {
        return showErrorToast("Enter a valid deposit amount");
      }

      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(
        `imb-request?amount=${finalAmount}`,
        "GET",
        null,
        headers
      );

      if (res?.data?.status === true && res?.data?.payment_url) {
        showSuccessToast("Redirecting to payment gateway...");
        setTimeout(() => {
          window.location.href = res.data.payment_url;
        }, 1200);
      } else {
        showErrorToast(res?.data?.msg || "Payment Failed");
      }
    } catch (err) {
      showErrorToast("Connection Failed. Please try again.");
    }
  };

  const translations = {
    hi: {
      addMoney: "पैसे जोड़ने के लिए राशि चुनें",
      money: "राशि डालें (₹)",
      next: "आगे बढ़ें",
      addAmount: "राशि जोड़ी जानी है:",
      referPerson: "रेफ़रल | ",
    },
    en: {
      addMoney: "ADD MONEY",
      money: "ENTER AMOUNT",
      next: "PROCEED TO PAY",
      addAmount: "Amount to be added:",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;

  return (
    <>
      <Header user={userAllData} />
      <ToastContainer limit={3} />

      <div className="ce-addcase-wrapper leftContainer mb_space mt-5 pt-5">
        <div className="ce-addcase-container">
          {!process1 && (
            <div>
              {/* --- STEP 1: SELECT AMOUNT --- */}
              {next === 1 && (
                <div className="ce-addcase-card animate-fade">
                  
                  {/* Top Header Card */}
                  <div className="ce-addcase-hero-header">
                    <div className="ce-hero-header-left">
                      <div className="ce-hero-pill">
                        <Sparkles size={13} className="ce-emerald-icon" />
                        <span>INSTANT TOP-UP</span>
                      </div>
                      <h1 className="ce-hero-title">{t.addMoney}</h1>
                      <p className="ce-hero-sub">Recharge wallet and continue playing</p>
                    </div>

                    <div className="ce-wallet-badge">
                      <span className="ce-wallet-label">WALLET</span>
                      <span className="ce-wallet-val">₹{userAllData?.Wallet_balance || "0"}</span>
                    </div>
                  </div>

                  {/* Input Box Block */}
                  <div className="ce-amount-input-card">
                    <span className="ce-input-card-title">{t.money}</span>
                    <div className="ce-amount-field-wrapper">
                      <div className="ce-currency-box">
                        <span>₹</span>
                      </div>
                      <input
                        className="ce-amount-field"
                        type="tel"
                        placeholder="0"
                        value={global || ""}
                        onChange={(e) => {
                          const val = parseInt(e.target.value) || 0;
                          if (val > 50000) setGlobal(50000);
                          else setGlobal(val);
                        }}
                      />
                    </div>

                    <div className="ce-input-footer-info">
                      <span className="ce-min-limit-text">Min ₹{minLimit || 50}</span>
                      <span className="ce-rate-conversion-text">
                        <Coins size={12} className="ce-coin-icon" /> 1 coin = ₹1
                      </span>
                    </div>
                  </div>

                  {/* Quick Pick Chips Grid */}
                  <div className="ce-quick-pick-section">
                    <span className="ce-quick-pick-label">QUICK PICK</span>
                    <div className="ce-chips-grid">
                      {[100, 250, 500, 1000, 2000, 5000].map((chipVal) => (
                        <button
                          key={chipVal}
                          type="button"
                          className={`ce-chip-btn ${
                            global === chipVal ? "active" : ""
                          }`}
                          onClick={() => setGlobal(chipVal)}
                        >
                          <span>₹{chipVal.toLocaleString()}</span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Feature Badges Row */}
                  <div className="ce-feature-pills-grid">
                    <div className="ce-feature-pill">
                      <Zap size={14} className="ce-emerald-icon" />
                      <span>Instant credit</span>
                    </div>
                    <div className="ce-feature-pill">
                      <ShieldCheck size={14} className="ce-emerald-icon" />
                      <span>Secure deposit</span>
                    </div>
                  </div>

                  {/* Action Button */}
                  <div className="ce-action-btn-area">
                    {addCaseSetting.isDeposit ? (
                      <button
                        type="button"
                        className="ce-primary-submit-btn"
                        onClick={handleNext}
                      >
                        <span>{t.next}</span>
                        <ArrowRight size={18} />
                      </button>
                    ) : (
                      <div className="ce-service-closed-banner">
                        <AlertTriangle className="ce-alert-icon" size={18} />
                        <span>Deposit services are temporarily paused.</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* --- STEP 2: CHOOSE PAYMENT METHOD --- */}
              {next === 2 && (
                <div className="ce-addcase-card animate-fade">
                  <div className="ce-amount-summary-strip">
                    <div className="ce-summary-left">
                      <span className="ce-summary-label">{t.addAmount}</span>
                      <span className="ce-summary-val">₹{global}</span>
                    </div>
                    <button
                      type="button"
                      onClick={() => setNext(1)}
                      className="ce-edit-amount-btn"
                    >
                      <Edit2 size={13} /> Edit
                    </button>
                  </div>

                  <div className="ce-section-divider-title">
                    <span>Select Payment Option</span>
                  </div>

                  <div className="ce-gateways-list">
                    {/* PhonePe */}
                    {Boolean(isPhonePayActive) && (
                      <div
                        onClick={() => fetchPaymentUrl()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Pay Now Option 1</strong>
                            <span>Instant Auto-Credit</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    )}

                    {/* IMB / UPI Gateway 1 */}
                    {global >= manualData?.upiGatewayMin &&
                    Boolean(isUpiGateway) &&
                    global <= manualData?.upiGatewayMax ? (
                      <div
                        onClick={() => handleIMBGateway()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Scan QR Code (Instant)</strong>
                            <span>Auto approval gateway</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* UPI Gateway 02 */}
                    {global >= manualData?.upiGatewayMin2 &&
                    Boolean(isUpiGateway02) &&
                    global <= manualData?.upiGatewayMax2 ? (
                      <div
                        onClick={() => upigateway02()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Pay QR Code Option 2</strong>
                            <span>Fast processing</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* PG UPI Gateway 03 */}
                    {global >= manualData?.upiGatewayMin3 &&
                    Boolean(isUpiGateway03) &&
                    global <= manualData?.upiGatewayMax3 ? (
                      <div
                        onClick={() => pgupigateway()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Pay QR Code Option 3</strong>
                            <span>Seamless checkout</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* Payin One */}
                    {global >= manualData?.payinMin &&
                    Boolean(payinOne) &&
                    global <= manualData?.payinMax ? (
                      <div
                        onClick={() => payinnn()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Express Pay Now</strong>
                            <span>Direct UPI redirect</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* Payin Two */}
                    {global >= manualData?.payinMin &&
                    Boolean(payinTwo) &&
                    global <= manualData?.payinMax ? (
                      <div
                        onClick={() => paymy()}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <img src="/UPI.png" alt="UPI" className="ce-gw-logo" />
                          <div className="ce-gw-text">
                            <strong>Express Pay Option 2</strong>
                            <span>Quick payment link</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* Pay with Account Transfer */}
                    {manualData?.isAccountActive &&
                    global >= manualData?.upiMin &&
                    global <= manualData?.upiMax ? (
                      <div
                        onClick={() => setNext(4)}
                        className="ce-gateway-option-card bank-card"
                      >
                        <div className="ce-gateway-card-left">
                          <div className="ce-bank-icon-box">
                            <Building2 size={22} />
                          </div>
                          <div className="ce-gw-text">
                            <strong>Bank Account Transfer</strong>
                            <span>IMPS / NEFT / RTGS</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* Manual QR Code 1 */}
                    {manualData?.isPayNowOne &&
                    global >= manualData?.upiMin &&
                    global <= manualData?.upiMax ? (
                      <div
                        onClick={() => {
                          setNext(3);
                          getImageUrl(PayOneImage, PayNow1Url);
                        }}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <div className="ce-bank-icon-box cyan">
                            <QrCode size={22} />
                          </div>
                          <div className="ce-gw-text">
                            <strong>Manual QR Code 1</strong>
                            <span>Scan and upload UTR</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}

                    {/* Manual QR Code 2 */}
                    {manualData?.isPayNowTwo ? (
                      <div
                        onClick={() => {
                          setNext(3);
                          getImageUrl(PayTwoImage, PayNow2Url);
                        }}
                        className="ce-gateway-option-card"
                      >
                        <div className="ce-gateway-card-left">
                          <div className="ce-bank-icon-box cyan">
                            <QrCode size={22} />
                          </div>
                          <div className="ce-gw-text">
                            <strong>Manual QR Code 2</strong>
                            <span>Scan and upload UTR</span>
                          </div>
                        </div>
                        <ArrowRight className="ce-gw-arrow" size={18} />
                      </div>
                    ) : null}
                  </div>

                  {/* WhatsApp Support Deposit Option */}
                  {global >= manualData?.whatsappRangemin &&
                    Boolean(manualData?.whatsappDeposit) &&
                    global <= manualData?.whatsappRangemax && (
                      <div className="ce-whatsapp-deposit-container">
                        <div className="ce-wa-deposit-info">
                          <h5>Manual WhatsApp Deposit</h5>
                          <p>{addCaseSetting?.whatsappDepositmsg}</p>
                        </div>
                        <a
                          className="ce-whatsapp-action-btn"
                          href={`https://wa.me/+91${addCaseSetting?.whatsappDepositNo}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ExternalLink size={16} />
                          <span>Connect on WhatsApp</span>
                        </a>
                      </div>
                    )}
                </div>
              )}

              {/* --- STEP 3: MANUAL QR & UTR SCREEN --- */}
              {next === 3 && (
                <div className="ce-addcase-card animate-fade">
                  <div className="ce-notice-box warning">
                    <AlertTriangle className="ce-notice-icon" size={18} />
                    <span>
                      कृपया सुनिश्चित करें कि आप मैन्युअल डिपॉजिट अमाउंट के
                      बराबर ही भुगतान करें। UTR नंबर और स्क्रीनशॉट के बिना कम या
                      ज्यादा पेमेंट ऐड नहीं होगा।
                    </span>
                  </div>

                  <div className="ce-manual-qr-display-box">
                    <h4 className="ce-qr-title">Scan & Pay ₹{global}</h4>
                    <div className="ce-qr-img-frame">
                      <img
                        src={`${baseUrl}/${ImageUrl}`}
                        alt="Payment QR Code"
                        className="ce-qr-img"
                      />
                    </div>

                    {PayNow1Url && (
                      <div className="ce-copy-url-bar">
                        <span className="ce-url-text">{PayNow1Url}</span>
                        <button className="ce-copy-sm-btn" onClick={copyCode}>
                          <Copy size={14} /> Copy
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    className="ce-primary-submit-btn"
                    onClick={handleShow_won}
                  >
                    <Upload size={18} />
                    <span>Upload Payment Details</span>
                  </button>
                </div>
              )}

              {/* --- STEP 4: BANK ACCOUNT DETAILS SCREEN --- */}
              {next === 4 && (
                <div className="ce-addcase-card animate-fade">
                  <div className="ce-notice-box info">
                    <ShieldCheck className="ce-notice-icon" size={18} />
                    <span>
                      पेमेंट करने के बाद स्क्रीनशॉट और UTR नंबर डालकर सबमिट करें।
                      गलत डिटेल्स डालने पर डिपॉजिट ऐड नहीं होगा।
                    </span>
                  </div>

                  <div className="ce-bank-details-card">
                    <div className="ce-bank-detail-row">
                      <span className="ce-detail-label">Account Number</span>
                      <div className="ce-detail-value-wrap">
                        <strong className="ce-detail-value">
                          {manualData?.acNo || "N/A"}
                        </strong>
                        <button className="ce-copy-sm-btn" onClick={copyCode1}>
                          <Copy size={14} />
                        </button>
                      </div>
                    </div>

                    <div className="ce-bank-detail-row">
                      <span className="ce-detail-label">Beneficiary Name</span>
                      <div className="ce-detail-value-wrap">
                        <strong className="ce-detail-value">
                          {manualData?.acName || "N/A"}
                        </strong>
                        <button className="ce-copy-sm-btn" onClick={copyCode2}>
                          <Copy size={14} />
                        </button>
                      </div>
                    </div>

                    <div className="ce-bank-detail-row">
                      <span className="ce-detail-label">IFSC Code</span>
                      <div className="ce-detail-value-wrap">
                        <strong className="ce-detail-value">
                          {manualData?.ifsccode || "N/A"}
                        </strong>
                        <button className="ce-copy-sm-btn" onClick={copyCode3}>
                          <Copy size={14} />
                        </button>
                      </div>
                    </div>
                  </div>

                  <button
                    className="ce-primary-submit-btn"
                    onClick={handleShow_won}
                  >
                    <Upload size={18} />
                    <span>Upload Payment Details</span>
                  </button>
                </div>
              )}
            </div>
          )}

          {process1 && (
            <div className="ce-loader-overlay">
              <img
                src="/images/LandingPage_img/loaderred.gif"
                alt="Loading..."
                className="ce-loader-gif"
              />
            </div>
          )}
        </div>

        {/* --- UPLOAD DETAILS MODAL --- */}
        <Modal
          show={show_won}
          onHide={handleClose_won}
          className="ce-upload-modal-dialog"
          centered
        >
          <Modal.Header closeButton className="ce-upload-modal-header">
            <Modal.Title className="ce-upload-modal-title">
              <Upload size={18} className="ce-emerald-icon" />
              <span>Submit Payment Proof</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="ce-upload-modal-body">
            <div className="ce-form-field-group">
              <label className="ce-field-label">Amount (₹)</label>
              <input
                className="ce-input-readonly"
                type="number"
                value={global}
                readOnly
              />
            </div>

            <div className="ce-form-field-group mt-3">
              <label className="ce-field-label">
                12-Digit UTR / Reference No.
              </label>
              <input
                className="ce-input-field"
                type="text"
                value={utr}
                onChange={(e) => setutr(e.target.value)}
                placeholder="Enter 12-digit UTR Number"
                required
              />
            </div>

            <div className="ce-file-upload-dropzone mt-3">
              <input
                type="file"
                onChange={handleChange}
                accept="image/*"
                required
                className="ce-file-input-hidden"
              />
              {!scrnshot ? (
                <div className="ce-dropzone-placeholder">
                  <Upload className="ce-dz-icon" size={24} />
                  <span>Click to Upload Payment Screenshot</span>
                </div>
              ) : (
                <div className="ce-uploaded-file-info">
                  <CheckCircle2 size={18} className="ce-file-check-icon" />
                  <span className="ce-file-name-text">{scrnshot.name}</span>
                  <button
                    type="button"
                    className="ce-clear-file-btn"
                    onClick={clearImage}
                  >
                    <X size={14} /> Remove
                  </button>
                </div>
              )}
            </div>

            {scrnshot1 && (
              <div className="ce-screenshot-preview-wrapper mt-3">
                <img
                  src={scrnshot1}
                  alt="Preview"
                  className="ce-ss-preview-img"
                />
              </div>
            )}

            <div className="ce-modal-actions-area mt-4">
              {isLoading1 ? (
                <button className="ce-primary-submit-btn" disabled>
                  <Spinner animation="border" size="sm" /> Submitting...
                </button>
              ) : (
                <button
                  type="button"
                  className="ce-primary-submit-btn"
                  onClick={ManualPayments}
                  disabled={!utr || !scrnshot}
                >
                  Submit Payment Details
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>

        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>
    </>
  );
};

export default Addcase;